import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { IconNoShelf } from '@/icons';
import { Flex } from '@/ui/Flex/Flex';
import { T } from '@/ui/Text/Text';

const StyledFlex = styled(Flex)`
  margin-right: 120px;
`;

export const NoShelf = () => (
  <Flex align="center" direction="column" gap={32} grow justify="center">
    <IconNoShelf />
    <StyledFlex direction="column" gap={12}>
      <T h1>
        <FormattedMessage defaultMessage="No Shelfs" id="p80EDU" />
      </T>
      <T body1>
        <FormattedMessage defaultMessage="Please come back later" id="7Lhi2X" />
      </T>
    </StyledFlex>
  </Flex>
);
